// Utils
import equal from 'NewAngular/utils/equal/deep-equal';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import { TECH_CHART_SECURITY_KEYS, TECHNICAL_KEYS } from 'ChartApp/ts/features/tech-chart/constants';
class TechnicalCustomSerializer {
}
TechnicalCustomSerializer.color = (_color) => encodeURIComponent(_color);
TechnicalCustomSerializer.params = (_params) => {
    const flattenedParams = _params.map((param) => {
        if (Array.isArray(param)) {
            return `(${param.map((p) => p.toString(10)).join(',')})`;
        }
        return param;
    });
    return flattenedParams.join(',');
};
function serializeTechnical(technical) {
    if (!equal(Object.keys(technical).sort(), TECHNICAL_KEYS)) {
        return '';
    }
    const flattenedTechnical = formFlattenedObject(technical, ['type', 'params', 'include', 'color'], TechnicalCustomSerializer);
    let serializedTechnical = '';
    Object.entries(flattenedTechnical).forEach(([key, value]) => {
        serializedTechnical = serializedTechnical.concat(`${key}::${value},,`);
    });
    // Remove trailing delim
    serializedTechnical = serializedTechnical.slice(0, serializedTechnical.lastIndexOf(',,'));
    return serializedTechnical;
}
class SecurityCustomSerializer {
}
SecurityCustomSerializer.color = (_color) => encodeURIComponent(_color);
SecurityCustomSerializer.id = (_id) => encodeURIComponent(_id);
function serializeSecurity(security) {
    if (!equal(Object.keys(security).sort(), TECH_CHART_SECURITY_KEYS)) {
        return '';
    }
    const flattenedSecurity = formFlattenedObject(security, ['id', 'color'], SecurityCustomSerializer);
    let serializedSecurity = '';
    TECH_CHART_SECURITY_KEYS.forEach((key) => {
        serializedSecurity = serializedSecurity.concat(`${key}:::${flattenedSecurity[key]},,,`);
    });
    // Remove trailing delim
    serializedSecurity = serializedSecurity.slice(0, serializedSecurity.lastIndexOf(',,,'));
    return serializedSecurity;
}
export class TechChartUrlSerializer {
}
TechChartUrlSerializer.chartAnnotations = (_chartAnnotations) => {
    if (!_chartAnnotations)
        return '';
    return _chartAnnotations.join(',');
};
TechChartUrlSerializer.security = (_security) => {
    if (!_security)
        return '';
    return serializeSecurity(_security);
};
TechChartUrlSerializer.technicals = (_technicals) => {
    if (!Array.isArray(_technicals))
        return '';
    const technicalParamStrs = _technicals.map(serializeTechnical).filter((s) => s !== '');
    return technicalParamStrs.join(',,,');
};
